import ServicePage from '../servicePage/ServicePage';
import { salesforceServiceData } from '../../data/salesforceServiceData';

const SalesforcePage = () => {
  return <ServicePage serviceData={salesforceServiceData} />;
};

export default SalesforcePage;